import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "home"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_GrasshopperTabs = _resolveComponent("GrasshopperTabs");
  const _component_Layout = _resolveComponent("Layout");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Layout, null, {
    default: _withCtx(() => [_ctx.categories !== [] ? (_openBlock(), _createBlock(_component_GrasshopperTabs, {
      key: 0,
      categories: _ctx.categories
    }, null, 8, ["categories"])) : _createCommentVNode("", true)]),
    _: 1
  })]);
}